import { Injectable } from '@angular/core';
import { BroadcastChannel } from 'broadcast-channel';

export interface BroadCastAction {
  type: string;
  payload?: any;
}

@Injectable()
export class BroadcastService {
  private broadcastChannel: BroadcastChannel;

  constructor() {
    this.broadcastChannel = new BroadcastChannel('rewards_dashboard_channel');
  }

  postMessage<T extends BroadCastAction>(event: T): void {
    this.broadcastChannel?.postMessage(event);
  }

  registerMessageHandler<T extends BroadCastAction>(
    callback: (data: T) => void,
  ): void {
    this.broadcastChannel?.addEventListener('message', (event: T) =>
      callback(event),
    );
  }
}
